import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import sunkenImage from './images/sunkenForest.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Sailor's Haven/Sunken Forest"
      meta={[
        { name: 'description', content: 'Sailor’s Haven is a wonderfully remote location on Fire Island that should not be missed.  The Sunken Forest is one of the last remaining maritime forests on the eastern seaboard.' },
        { name: 'keywords', content: 'Sailor\'s Haven, Sunken Forest, Holly Forest, Fire Island, Ferries, New York, Long Island, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Sailor's Haven/Sunken Forest">
        <h2>Communities</h2>
        <h1>Sailor's Haven/Sunken Forest</h1>
        <p>Amenities</p>
        <div className="amenities">
          { Amenities.byBeach('Sailor\'s Haven/Sunken Forest').map(item => (
            <i key={item.text} className={`icon-${item.icon}`} title={item.text} />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="http://www.sayvilleferry.com/">Schedules</Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About Sailor's Haven/Sunken Forest</h1>
          </div>
          <p>
            Sailor’s Haven is a wonderfully remote location on Fire Island that should not be missed.  It has a 42 slip marina, a snack bar, picnic area, and visitor center.  
            Visitors may find National Seashore Rangers in the area ready to provide interesting information about the foliage and wild life of Fire Island.
          </p>
          <p>
            Sailor’s Haven is also home to the majestic Sunken Forest.  The Sunken Forest is one of the last remaining maritime forests on the eastern seaboard.  
            This peaceful forest consists of approximately forty acres of American Holly, Sassafras, and Shadblow with meandering boardwalks.  
            Sunken Forest’s name is derived from the fact it is sunken behind the sand dunes that protect it from the harsh Atlantic winds, but often is mistaken to be below sea level.  
          </p>
        </div>
        <div className="col-xl-4">
          <Beach image={sunkenImage} link="https://www.nps.gov/fiis/planyourvisit/sunken-forest.htm" beach="Sunken Forest" description="Explore the winding boardwalks of this maritime rarity." className="mx-auto" />
        </div>
      </div>
      <Tip title="Captain's Tip">
        When visiting Sailor’s Haven and the Sunken Forest we recommend bug spray.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Sailor's Haven/Sunken Forest is available by <Link to="http://www.sayvilleferry.com/">Sayville Ferry</Link> located in Sayville, NY.
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is available to and from Sailor's Haven/Sunken Forest during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
